export var IMAGE_POSITION_LEFT = 'left';
export var IMAGE_POSITION_RIGHT = 'right';
export var IMAGE_POSITION_TOP = 'top';
export var IMAGE_POSITION_BOTTOM = 'bottom';
export var IMAGE_POSITION_BACKGROUND = 'background';
export var HORIZONTAL_POSITIONS = [IMAGE_POSITION_LEFT, IMAGE_POSITION_RIGHT];
export var IMAGE_POSITIONS = [IMAGE_POSITION_LEFT, IMAGE_POSITION_RIGHT, IMAGE_POSITION_TOP, IMAGE_POSITION_BOTTOM, IMAGE_POSITION_BACKGROUND];
export var FIRST_POSITIONS = [IMAGE_POSITION_LEFT, IMAGE_POSITION_TOP];
export var VERTICAL_POSITIONS = [IMAGE_POSITION_TOP, IMAGE_POSITION_BOTTOM];
export var CONTENT_TYPE_MARKDOWN = 'MARKDOWN';
export var FAST_ID_CUSTOM_FORM = 'CustomForm';